import { produce } from "immer";

import { configSchema, type Config } from "@hsl/core/fund-page/schemas";
import type { ProductType } from "@hsl/lgim-explorer/src/config/types";

/***************************************
 * PROCESS CONFIG
 *****************************************/
export function processConfig(config: Config) {
    const processedConfig = configSchema.parse(config);
    return produce(processedConfig, (output) => {
        /**********************
         * PRODUCT TYPE
         ***********************/
        let productType: ProductType;
        switch (config.umbrellaId) {
            case 116:
                productType = "pmc";
                break;
            case 19:
                productType = "etf";
                break;
            default:
                productType = "collective";
                break;
        }
        output.productType = productType;
        /**********************
         * FUND CENTRE ID
         **********************/
        if (!config.fundCentreId) {
            throw new Error("No fund centre IDs in config");
        }
        const matchingIds = config.fundCentreId.filter((idConfig) => {
            const audienceMatch = idConfig.audiences.includes(
                config.audienceId,
            );
            const productTypeMatch =
                "productType" in idConfig
                    ? idConfig.productType === productType
                    : true;
            return audienceMatch && productTypeMatch;
        });

        if (matchingIds.length === 0) {
            throw new Error(
                "No fund centre ID found for this audience and product type",
            );
        }

        const id = matchingIds.reduce((a, b) => {
            return Object.keys(a).length > Object.keys(b).length ? a : b;
        }, {} as (typeof matchingIds)[number]).id;

        if (!id) {
            throw new Error("No fund centre ID found for this audience");
        }

        output.id = id;
    });
}
